import { createContext } from "react";

const adminNavContext = createContext();

export default adminNavContext;
